
import { defineComponent } from 'vue';
import { endpointHeaderComposition, productComposition } from '../services';
import { pdfEndpointComposition } from '@/core/modules/pdfViewer/services';
import { panelComposition } from '@/core/modules/panel/services';
import { overlayComposition } from '@/core/modules/overlay/services';

import { toKebabCaseId } from '@/core/services/core.utils';

export default defineComponent({
    setup() {
        return {
            toKebabCaseId,
            ...endpointHeaderComposition(),
            ...pdfEndpointComposition(),
            ...panelComposition(),
            ...productComposition(),
            ...overlayComposition()
        }
    }
})
